module.exports = __webpack_public_path__ + "static/LB-logo-monograma-1-ae453fb5ac6960db7a4e4e75051361f6.png";